export const RCL_PLACEHOLDERS = [
	'I’m looking for cruises departing from Miami in the spring',
	'Find cruises visiting CocoCay next summer',
	'Show me cruises to Alaska for more than 5 nights',
	'Sail to the Caribbean on the Icon of the Seas in May next year',
];

export const CEL_PLACEHOLDERS = [
	'I’m looking for cruises departing from Miami in the spring',
	'Find cruises visiting the Caribbean next summer',
	'Show me cruises to Alaska for more than 5 nights',
	'Sail to the Caribbean on the Celebrity Beyond in May next year',
];

export const RCL_KEYWORDS = [
	'Adventure of the Seas',
	'Alaska',
	'Alicante',
	'Allure of the Seas',
	'Amalfi Coast (Salerno)',
	'Amsterdam',
	'Anthem of the Seas',
	'April',
	'Arabian Gulf',
	'Argentina',
	'Argostoli',
	'Asia',
	'Astoria',
	'Athens (Piraeus)',
	'Athens',
	'August',
	'Australia',
	'Bahamas',
	'Baltimore',
	'Bar Harbor',
	'Barcelona',
	'Bari',
	'Basseterre',
	'Beijing',
	'Belize City',
	'Bermuda',
	'Bilbao',
	'Bimini',
	'Bologna (Ravenna)',
	'Boston',
	'Bridgetown',
	'Brilliance of the Seas',
	'Brisbane',
	'British Columbia',
	'Buenos Aires',
	'Cabo San Lucas',
	'Cadiz',
	'California',
	'Canada',
	'Cape Liberty',
	'Caribbean',
	'Cartagena',
	'Castries',
	'Catalina Island',
	'Chania (Souda)',
	'Charleston',
	'Chile',
	'China',
	'Civitavecchia',
	'CocoCay',
	'Colombia',
	'Colon',
	'Copenhagen',
	'Corfu',
	'Cozumel',
	'Cyprus',
	'December',
	'Denmark',
	'Dubai',
	'Enchantment of the Seas',
	'Endicott Arm & Dawes Glacier',
	'England',
	'Ensenada',
	'Europe',
	'Explorer of the Seas',
	'Falmouth',
	'February',
	'Florence / Pisa (Carrara)',
	'Florence / Pisa (La Spezia)',
	'Florida',
	'Fort De France',
	'Fort Lauderdale',
	'Freedom of the Seas',
	'Fremantle',
	'Fuerte Amador',
	'Galveston',
	'Genoa',
	'Gijon',
	'Glacier Bay (Cruising)',
	'Gran Canaria',
	'Grand Bahama Island',
	'Grandeur of the Seas',
	'Greece',
	'Haifa',
	'Haines',
	'Harmony of the Seas',
	'Hawaii (Kailua Kona)',
	'Hawaii',
	'Hilo',
	'Hong Kong',
	'Honolulu',
	'Huatulco',
	'Hubbard Glacier',
	'Ibiza',
	'Icon of the Seas',
	'Icy Strait Point',
	'Independence of the Seas',
	'Iraklion (Heraklion)',
	'Israel',
	'Istanbul',
	'Italy',
	'January',
	'Japan',
	'Jewel of the Seas',
	'July',
	'June',
	'Juneau',
	'Kauai (Nawiliwili)',
	'Ketchikan (Ward Cove)',
	'Ketchikan',
	'Key West',
	'La Coruna',
	'La Palma',
	'La Romana',
	'Labadee',
	'Lanzarote',
	'Latin America',
	'Liberty of the Seas',
	'Limassol',
	'Los Angeles',
	'Louisiana',
	'Manzanillo',
	'March',
	'Mariner of the Seas',
	'Maryland',
	'Massachusetts',
	'Maui (Lahaina)',
	'May',
	'Mazatlan',
	'Mexico',
	'Miami',
	'Montego Bay',
	'Mount Kilauea (Cruising)',
	'Mykonos',
	'Málaga',
	'Napali Coast (Cruising)',
	'Naples / Capri',
	'Nassau',
	'Navigator of the Seas',
	'Netherlands',
	'New England',
	'New Jersey',
	'New Orleans',
	'New York',
	'New Zealand',
	'Newport',
	'November',
	'Oahu (Honolulu)',
	'Oahu',
	'Oasis of the Seas',
	'Ocho Rios',
	'October',
	'Odyssey of the Seas',
	'Olympia (Katakolon)',
	'Orlando (Port Canaveral)',
	'Orlando',
	'Ovation of the Seas',
	'Pacific Northwest',
	'Palma De Mallorca',
	'Panama City',
	'Panama',
	'Perfect Day at CocoCay',
	'Perth',
	'Piraeus',
	'Pointe A Pitre',
	'Ponce',
	'Port Canaveral',
	'Portland',
	'Portofino',
	'Puerto Costa Maya',
	'Puerto Plata',
	'Puerto Rico',
	'Puerto Vallarta',
	'Punta Cana',
	'Quantum of the Seas',
	'Quebec City',
	'Quebec',
	'Radiance of the Seas',
	'Ravenna',
	'Repositioning',
	'Rhapsody of the Seas',
	'Rhodes',
	'Rockland',
	'Rome (Civitavecchia)',
	'Rome',
	'San Diego',
	'San Francisco',
	'San Juan',
	'Santa Barbara',
	'Santorini',
	'Sardinia (Cagliari)',
	'Seattle',
	'September',
	'Serenade of the Seas',
	'Seville (Cadiz)',
	'Seward',
	'Sicily (Catania)',
	'Sicily (Messina)',
	'Sicily (Palermo)',
	'Sicily (Siracusa)',
	'Singapore',
	'Sitka',
	'Skagway',
	'Skiathos',
	'South Pacific',
	'Southampton',
	'Spain',
	'Spectrum of the Seas',
	'Star of the Seas',
	'Sydney',
	'Symphony of the Seas',
	'Tampa',
	'Tarragona',
	'Tenerife',
	'Texas',
	'The Pacific',
	'Thessaloniki',
	'Tianjin',
	'Tokyo',
	'Tracy Arm Fjord',
	'Transatlantic',
	'Transpacific',
	'Turkey',
	'United Arab Emirates',
	'Utopia of the Seas',
	'Valencia',
	'Valparaiso',
	'Vancouver',
	'Venice',
	'Vigo',
	'Vision of the Seas',
	'Voyager of the Seas',
	'Washington',
	'Wonder of the Seas',
	'Yokohama',
	'Yucatan (Progreso)',
	'Zakynthos',
];

export const CEL_KEYWORDS = [
	'Ajaccio,Corsica ',
	'Akureyri,Iceland',
	'Alaska',
	'Alaska Inside Passage',
	'Alesund,Norway',
	'Alexandria,Egypt',
	'Alicante,Spain',
	'Amsterdam',
	'Amsterdam,Netherlands',
	'Apex',
	'April',
	'Ascent',
	'Asia',
	'Astoria,Oregon',
	'Athens',
	'AuckLand',
	'August',
	'Australia',
	'Bahamas',
	'Baltra Island',
	'Barcelona',
	'Barcelona,Spain',
	'Basseterre,St Kitts & Nevis',
	'Belfast,Northern Ireland',
	'Belize City,Belize',
	'Benoa,Bali',
	'Bergen,Norway',
	'Berlin,Germany',
	'Bermuda',
	'Beyond',
	'Bilbao,Spain',
	'Bimini,Bahamas',
	'Bordeaux (La Rochelle),France',
	'Bordeaux (Pauillac),France',
	'Boston',
	'Boston,Massachusetts',
	'Bridgetown,Barbados',
	'Brindisi,Italy',
	'Bruges (Zeebrugge),Belgium',
	'Buenos Aires',
	'Buenos Aires,Argentina',
	'Cabo San Lucas,Mexico',
	'Cagliari,Sardinia,Italy',
	'Canada',
	'Cannes,France',
	'Cape Liberty',
	'Cape Liberty,New Jersey',
	'Caribbean',
	'Cartagena,Colombia',
	'Cartagena,Spain',
	'Castries,St. Lucia',
	'Catalina Island,California',
	'Charlotte Amalie,St. Thomas',
	'Charlottetown,Prince Edward Island',
	'Colon,Panama',
	'Constellation',
	'Copenhagen,Denmark',
	'Corfu,Greece',
	'Cork (Cobh),Ireland',
	'Costa Maya,Mexico',
	'Cozumel,Mexico',
	'December',
	'Dover,England',
	'Dubrovnik,Croatia',
	'Eclipse',
	'Edge',
	'Ensenada,Mexico',
	'Equinox',
	'Europe',
	'Falmouth,Jamaica',
	'February',
	'Flam,Norway',
	'Flora',
	'Florence/Pisa (La Spezia),Italy',
	'Florence/Pisa (Livorno),Italy',
	'Fort De France,Martinique',
	'Fort Lauderdale',
	'Fort Lauderdale,Florida',
	'Fuerteventura,Canary Islands',
	'Galapagos',
	'Geiranger,Norway',
	'Genoa,Italy',
	'George Town,Grand Cayman',
	'Gerlache Strait',
	'Gibraltar,United Kingdom',
	'Gran Canaria,Canary Islands',
	'Haifa,Israel',
	'Halifax,Nova Scotia',
	'Haugesund,Norway',
	'Hawaii',
	'Helsinki,Finland',
	'Hilo,Hawaii',
	'Hong Kong',
	'Honolulu',
	'Honolulu,Oahu,Hawaii',
	'Huatulco,Mexico',
	'Hubbard Glacier,Alaska',
	'Hydra,Greece',
	'Ibiza,Spain',
	'Icy Strait Point,Alaska',
	'Infinity',
	'Inside Passage',
	'Isafjordur,Iceland',
	'Istanbul,Turkey',
	'January',
	'Jerusalem (Ashdod),Israel',
	'July',
	'June',
	'Juneau,Alaska',
	'Kailua Kona,Hawaii',
	'Kavala,Greece',
	'Ketchikan,Alaska',
	'Key West,Florida',
	'Kotor,Montenegro',
	'Kralendijk,Bonaire',
	'Kristiansand,Norway',
	'La Coruna,Spain',
	'La Palma,Canary Islands',
	'Lahaina,Maui,Hawaii',
	'Lanzarote,Canary Islands',
	'Lima,Peru',
	'Limassol,Cyprus',
	'Lisbon',
	'Lisbon,Portugal',
	'Liverpool,England',
	'Los Angeles',
	'Los Angeles,California',
	'Madeira,Portugal',
	'Malaga,Spain',
	'Manta,Ecuador',
	'March',
	'Marthas Vineyard, Massachusetts',
	'May',
	'Mazatlan,Mexico',
	'Mexican Riviera',
	'Miami',
	'Miami,Florida',
	'Millennium',
	'Molde,Norway',
	'Moorea,French Polynesia',
	'Mumbai',
	'Mykonos,Greece',
	'Nafplio,Greece',
	'Naples,Italy',
	'Nassau,Bahamas',
	'New Orleans,Louisiana',
	'Nice (Villefranche),France',
	'November',
	'October',
	'Olden,Norway',
	'Oranjestad,Aruba',
	'Oslo,Norway',
	'Pacific Coastal',
	'Palma De Mallorca,Spain',
	'Panama',
	'Panama Canal',
	'Papeete,Tahiti,French Polynesia',
	'Paris (La Havre),France',
	'Philipsburg,St. Maarten',
	'Pisco (San Martin),Peru',
	'Ponta Delgada,Azores',
	'Portland,Dorset,United Kingdom',
	'Portland,Maine',
	'Porto,Portugal',
	'Portofino,Italy',
	'Prins Christian Sund',
	'Provence (Marseille),France',
	'Provence (Toulon),France',
	'Puerto Limon,Costa Rica',
	'Puerto Madryn,Argentina',
	'Puerto Vallarta,Mexico',
	'Puntarenas,Costa Rica',
	'Qaqortoq,Greenland',
	'Quebec City,Quebec',
	'Raiatea,French Polynesia',
	'Reflection',
	'Reykjavik,Iceland',
	'Rhodes,Greece',
	'Roatan,Honduras',
	'Rockland,Maine',
	'Rome',
	'Rome (Civitavecchia),Italy',
	'Roseau,Dominica',
	'Rotterdam',
	'Rotterdam,Netherlands',
	'Royal Naval Dockyard,Bermuda',
	'San Diego,California',
	'San Francisco,California',
	'San Juan',
	'San Juan,Puerto Rico',
	'Santa Barbara,California',
	'Santa Margherita,Italy',
	'Santorini,Greece',
	'Seattle',
	'Seattle,Washington',
	'September',
	'Seville,Spain',
	'Seward',
	'Seward,Alaska',
	'Seydisfjordur,Iceland',
	'Sicily (Messina),Italy',
	'Sicily (Palermo),Italy',
	'Silhouette',
	'Singapore',
	'Sitka,Alaska',
	'Skagen,Denmark',
	'Skagway,Alaska',
	'Solstice',
	'South America',
	'Southampton',
	'Southampton,England',
	'Split,Croatia',
	'St. Georges, Grenada',
	'St. Johns, Antigua',
	'St. Peter Port,Channel Island',
	'Stavanger,Norway',
	'Stockholm,Sweden',
	'Strait Of Magellan',
	'Summit',
	'Sydney',
	'Sydney,Nova Scotia',
	'Tallinn,Estonia',
	'Tampa',
	'Tampa,Florida',
	'Taranto,Italy',
	'Tenerife,Canary Islands',
	'Thessaloniki,Greece',
	'Tokyo',
	'Tortola,British Virgin Islands',
	'Transatlantic',
	'Transpacific',
	'Trieste,Italy',
	'Tromso,Norway',
	'Ushuaia,Argentina',
	'Valencia,Spain',
	'Valparaiso',
	'Vancouver',
	'Vancouver, British Columbia',
	'Venice',
	'Venice,Italy',
	'Victoria, British Columbia',
	'Vigo,Spain',
	'Visby,Sweden',
	'Volos,Greece',
	'Waterford (Dunmore E.),Ireland',
	'Willemstad,Curacao',
	'Xpedition',
	'Xploration',
	'Zadar,Croatia',
	'Zakynthos,Greece',
];

export const timeoutMs = 60000;

export const errorMessages = {
	pii: 'Error: We cannot process your request with the information provided',
	generic: 'Error: An error occurred while processing your request. Please try again later.',
	zeroResults: "We're sorry, but we couldn't find any results that match your search. Please modify your search and try again.",
};

export const NL_INPUT_ID = ':r0:';
